import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.blog-roll__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          focus: 'center',
          arrows: true,
          gap: '20px',
          perPage: 3,
          paginationKeyboard: true,
          drag: true,
          pagination: false,
          start: 1,
          breakpoints: {
            768: {
              perPage: 1,
              arrows: false,
            },
          },
        } );
        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            drag: isOverflow,
          };
        } );
        slider.mount( );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'blog-roll', COMPONENT );
} )( app );
